(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lazy-featured-collection')) {
    class LazyFeaturedCollection extends HTMLElement {
      connectedCallback() {
        this.carousel = this.closest('featured-collections-carousel');
        this.onCarouselChange = this.onCarouselChange.bind(this);
        this.carousel?.addEventListener('carousel:change', this.onCarouselChange);
      }

      disconnectedCallback() {
        this.carousel?.removeEventListener('carousel:change', this.onCarouselChange);
      }

      onCarouselChange(event) {
        if (event.detail.cell.contains(this)) {
          this.load();
        }
      }

      async load() {
        if (this.hasAttribute('loaded') || this.getAttribute('aria-busy') === 'true') {
          return;
        }

        this.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(this.dataset.url, { credentials: 'same-origin' });

          if (!response.ok) {
            throw new Error('Unable to load collection');
          }

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const productList = documentFragment.querySelector('[data-lazy-featured-products]');

          if (!productList) {
            throw new Error('Collection products missing');
          }

          this.replaceChildren(...document.importNode(productList, true).childNodes);
          this.setAttribute('loaded', '');
          this.setAttribute('aria-busy', 'false');
        } catch (error) {
          this.setAttribute('aria-busy', 'false');
        }
      }
    }

    customElements.define('lazy-featured-collection', LazyFeaturedCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lazy-product-recommendations')) {
    customElements.define(
      'lazy-product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          const loadRecommendations = () => {
            if (this.dataset.loaded === 'true') return;

            this.dataset.loaded = 'true';
            this.observer?.disconnect();

            fetch(this.dataset.url, { credentials: 'same-origin' })
              .then((response) => response.text())
              .then((text) => {
                const html = new DOMParser().parseFromString(text, 'text/html');
                const recommendations = html.querySelector('lazy-product-recommendations');

                if (recommendations?.innerHTML.trim()) {
                  this.innerHTML = recommendations.innerHTML;
                }
              })
              .catch(() => {
                this.dataset.loaded = 'false';
              });
          };

          if (!('IntersectionObserver' in window)) {
            loadRecommendations();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;

              loadRecommendations();
            },
            { rootMargin: '800px 0px' }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const prepareCarousel = (carousel) => {
    if (carousel.dataset.deferredSlidesPrepared === 'true') return;

    carousel.dataset.deferredSlidesPrepared = 'true';

    const hydrateSlide = (slide, fetchPriority = 'auto') => {
      if (!slide) return;

      slide.querySelectorAll('img[fetchpriority="low"]').forEach((image) => {
        image.loading = 'eager';
        image.fetchPriority = fetchPriority;
        image.setAttribute('fetchpriority', fetchPriority);

        if (image.dataset.deferredSrcset) {
          image.srcset = image.dataset.deferredSrcset;
          image.removeAttribute('data-deferred-srcset');
        }

        if (image.dataset.deferredSrc) {
          image.src = image.dataset.deferredSrc;
          image.removeAttribute('data-deferred-src');
        }
      });

      slide.querySelectorAll('source[data-mobile-srcset]').forEach((source) => {
        source.srcset = source.dataset.mobileSrcset;
        source.removeAttribute('data-mobile-srcset');
      });
    };

    const loadDeferredImages = () => {
      carousel.querySelectorAll('.slideshow__slide').forEach(hydrateSlide);
    };

    const preloadNextImage = () => {
      const slides = Array.from(carousel.querySelectorAll('.slideshow__slide'));

      if (slides.length < 2) return;

      const selectedIndex = slides.findIndex((slide) => slide.classList.contains('is-selected'));
      const nextIndex = selectedIndex >= 0 ? (selectedIndex + 1) % slides.length : 1;

      hydrateSlide(slides[nextIndex], isMobile ? 'high' : 'auto');
    };

    carousel.addEventListener('pointerdown', loadDeferredImages, { once: true, passive: true });
    carousel.addEventListener('keydown', loadDeferredImages, { once: true });

    if (!carousel.hasAttribute('autoplay')) return;

    const cycleDuration = Number.parseFloat(carousel.getAttribute('autoplay')) * 1000;
    const isMobile = window.matchMedia('(max-width: 699px)').matches;
    const preloadDelay = isMobile ? 500 : Math.max(1000, cycleDuration - 2000);
    let preloadTimer;

    const scheduleNextPreload = () => {
      window.clearTimeout(preloadTimer);
      preloadTimer = window.setTimeout(preloadNextImage, preloadDelay);
    };

    scheduleNextPreload();
    carousel.addEventListener('carousel:select', scheduleNextPreload);
  };

  const prepareCarousels = (root = document) => {
    root.querySelectorAll('slideshow-carousel').forEach(prepareCarousel);
  };

  prepareCarousels();
  document.addEventListener('shopify:section:load', (event) => prepareCarousels(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
